import { ReactComponent as DeleteIcon } from '@/components/assets/icons/DeleteIcon.svg';
import { ReactComponent as DownloadIcon } from '@/components/assets/icons/DownloadIcon.svg';
import IconButton from '@/components/Button/IconButton';
import useVoiceFileList from '@/hooks/useVoiceFileList';
import { ExtendFileInfo } from '@/stores/cvc';
import {
  mssSourceFileListModel,
  mssSourceFileListSelector,
  selectedMssSourceFileListSelector,
} from '@/stores/mss';
import { mssUploadingStatesModel } from '@/stores/resource';
import { White } from '@/styles/Colors';
import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import useDownload from '../cvc/hooks/useDownload';

const MssSourceListControl = () => {
  const { t } = useTranslation();
  const setSourceList = useSetRecoilState(mssSourceFileListModel);
  const sourceList = useRecoilValue(mssSourceFileListSelector);
  const { deleteFiles } = useVoiceFileList(sourceList, setSourceList);
  const uploadingSourceStates = useRecoilValue(mssUploadingStatesModel);
  const onClickDelete = useCallback(() => {
    deleteFiles(uploadingSourceStates);
  }, [deleteFiles, uploadingSourceStates]);
  const selectedList = useRecoilValue(selectedMssSourceFileListSelector);
  const counter = useMemo(() => {
    const total = sourceList.length;
    return `${
      selectedList.length ? selectedList.length + ' / ' : ''
    }${total} File${total > 1 ? 's' : ''}`;
  }, [selectedList, sourceList]);
  const { onDownload } = useDownload();
  const onClickDownload = useCallback(async () => {
    const items = (await onDownload(selectedList)) as ExtendFileInfo[];
    setSourceList((prev) => {
      return prev.map((item) => {
        const newItem = items.find((v) => v.id === item.id);
        return {
          ...item,
          originalUrl: newItem?.originalUrl,
          transcodedUrl: newItem?.transcodedUrl,
        };
      });
    });
  }, [setSourceList, onDownload, selectedList]);
  return (
    <section
      className={classNames(
        'sup-file-info',
        !!selectedList.length && 'checked'
      )}
    >
      <span className="status">
        <span>{counter}</span>
      </span>
      <span className="buttons">
        <IconButton
          color={White}
          size="lg"
          variant="none"
          onClick={onClickDelete}
          tooltip={t('Delete Selections')}
          aria-label={t('Delete Selections') as string}
        >
          <DeleteIcon />
        </IconButton>
        <IconButton
          color={White}
          size="lg"
          variant="none"
          tooltip={t('Download Selections')}
          aria-label={t('Download Selections') as string}
          onClick={onClickDownload}
        >
          <DownloadIcon />
        </IconButton>
      </span>
    </section>
  );
};
export default MssSourceListControl;
